import VideoControls from '@utils/videoControls';

export default class StoryModule {
  constructor(context) {
    if (context.querySelector('.js--video-controls'))
      new VideoControls(context.querySelector('.js--video-controls'), context);
  }
}
